import { useEffect, useRef } from "react";
import { services } from "@/mocks/home";

export default function ServicesSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll(".animate-on-scroll");
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" ref={sectionRef} className="py-14 md:py-20 bg-background-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16 animate-on-scroll opacity-0 translate-y-6 transition-all duration-700">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-heading text-foreground-50">
            Nos Services
          </h2>
          <div className="w-24 h-1 bg-primary-500 mx-auto rounded-full mb-6"></div>
          <p className="text-foreground-50 max-w-2xl mx-auto">
            Nous concevons et orchestrons des événements mémorables qui captivent, inspirent et créent des moments inoubliables.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="animate-on-scroll opacity-0 translate-y-6 transition-all duration-700 bg-background-950/30 backdrop-blur-sm border border-background-200/20 p-6 rounded-xl hover:-translate-y-2 hover:shadow-xl hover:shadow-black/40 hover:border-primary-500/30 group"
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              {/* Icône */}
              <div className="w-12 h-12 flex items-center justify-center mb-5 rounded-full bg-background-950/50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-500">
                <i className={`${service.icon} text-xl`}></i>
              </div>

              {/* Titre */}
              <h3 className="text-lg font-semibold mb-3 text-foreground-50">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-foreground-50/60 leading-relaxed text-sm">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        .animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}